
<div class="body" [ngStyle]="{'background-image': 'url(' + bgrandom + ')'}">
    <app-menu (comunicarSeccion)="getSeccion($event)"></app-menu>
    <app-listado *ngIf="seccion && seccion.id && seccion.categoria !== 'Contacto'" [seccion]="seccion"></app-listado>
    <app-inicio *ngIf="!seccion || seccion.id === 0" ></app-inicio>
    <app-contacto id="contacto_form"></app-contacto>
    <app-footer class="footer"></app-footer>
</div>

<app-whatsapp *ngIf="checkWhatsApp()"></app-whatsapp>